import { Link, useLocation, useNavigate } from 'react-router-dom';
import RegistrationForm from '../components/forms/registration';

function resolveSafeNextPath(rawNext, fallback = '/profile') {
  if (typeof rawNext !== 'string' || rawNext.trim() === '') return fallback;
  if (!rawNext.startsWith('/')) return fallback;
  if (rawNext.startsWith('//')) return fallback;
  return rawNext;
}

export default function RegisterPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search || '');
  const nextPath = resolveSafeNextPath(params.get('next'), '/profile');
  const encodedNextPath = encodeURIComponent(nextPath);

  return (
    <div className="page">
      <section className="section">
        <div className="card" style={{ maxWidth: 500, marginInline: 'auto' }}>
          <h1 className="section-title">Create an Account</h1>

          <RegistrationForm onSuccess={({ verificationEmailSent } = {}) => {
            const params = new URLSearchParams({ next: nextPath });
            if (verificationEmailSent) params.set('sent', '1');
            navigate(`/verify-email?${params.toString()}`);
          }} />

          <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
            Already have an account? <Link to={`/login?next=${encodedNextPath}`}>Log in</Link>
          </p>
        </div>
      </section>
    </div>
  );
}
